<script lang="ts">
export let template: Template;
export let onTagClick: (tag: string) => void;

$: searchTags = template.SearchTags.split(" ");
</script>

<div class="container">
  <a class="anchor" href={template.NotionUrl} target="_blank">
    <img class="cover" src={template.CoverImageUrl} />
    <span class="title">
      {template.Title}
    </span>
    <span class="message">{template.Message}</span>
  </a>
  <div class="tags">
    {#each searchTags as tag}
      <div class="tag" on:click={() => onTagClick(tag)}>{tag}</div>
    {/each}
  </div>
</div>

<style type="text/scss">
.container {
  display: flex;
  flex-direction: column;

  .anchor {
    display: flex;
    flex-direction: column;
    text-decoration: none;
    color: inherit;
  }

  .cover {
    width: 100%;
    height: 160px;
    border-radius: 8px;
    object-fit: cover;
    margin-bottom: 8px;
    transition: 150ms;

    &:hover {
      filter: brightness(88%);
    }
  }

  .title {
    font-weight: bold;
    font-size: 24px;
    line-height: 1.2;
    margin-bottom: 8px;

    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2; /* number of lines to show */
    -webkit-box-orient: vertical;

    &:hover {
      text-decoration: underline;
    }
  }

  .message {
    font-weight: normal;
    color: rgba(0, 0, 0, 0.6);
    line-height: 1.5;

    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3; /* number of lines to show */
    -webkit-box-orient: vertical;
    word-break: break-word;

    margin-bottom: 16px;
  }

  .tags {
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    .tag {
      font-weight: 600;
      font-size: 14px;
      padding: 6px 8px;
      border: 1px solid rgb(55, 53, 47);
      border-radius: 16px;
      transition: 150ms;
      user-select: none;
      margin-bottom: 8px;
      cursor: pointer;

      &::before {
        content: "#";
      }

      &:not(:last-child) {
        margin-right: 4px;
      }

      &:hover {
        color: white;
        background-color: rgb(55, 53, 47);
      }
    }
  }
}
</style>
